var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.002,
    height: 20.877,
    viewBox: "0 0 21.002 20.877",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#004884",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    d: "M8.951 18.827v-8.763l-1.467 1.471a1.054 1.054 0 0 1-1.49-1.491l3.262-3.267a1.051 1.051 0 0 1 1.49 0l3.262 3.267a1.054 1.054 0 0 1 0 1.491 1.042 1.042 0 0 1-1.482 0l-1.469-1.471v8.763a1.053 1.053 0 0 1-2.105 0zM17.9 3.992V2.779a.669.669 0 0 0-.668-.671H2.781a.673.673 0 0 0-.678.671v1.213a1.053 1.053 0 0 1-2.103 0V2.779A2.789 2.789 0 0 1 2.781 0h14.448A2.782 2.782 0 0 1 20 2.779v1.213a1.052 1.052 0 0 1-2.1 0z",
    transform: "translate(.5 .5) rotate(180 10 9.938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download_icon.faad4bb45daa64ba9c02099222e22be8.svg";
export { ForwardRef as ReactComponent };